const TREX = {
  DEFAULT: {
    animation: 'TREX',
    width: 90,
    height: 88,
    spriteX: 1678,
    spriteY: 2
  },
  TREX_LEFT: {
    animation: 'TREX_LEFT',
    width: 90,
    height: 88,
    spriteX: 1852,
    spriteY: 2
  },
  TREX_RIGHT: {
    animation: 'TREX_RIGHT',
    width: 90,
    height: 88,
    spriteX: 1940,
    spriteY: 2
  }
};

export default TREX;
